import { gsap } from 'gsap'

export class Tab {
  constructor() {
    if (document.querySelector('.js-tab_trg') === null) return
    const tabTrgArr = Array.prototype.slice.call(document.querySelectorAll('.js-tab_trg'), 0)
    tabTrgArr.forEach(function (elm) {
      elm.addEventListener('click', (event) => {
        let $this = event.currentTarget
        tabSwitch($this)
      })
    })

    // タブをクリックすると実行する関数
    const tabSwitch = (elm) => {
      // 引数で指定したセレクターと一致する直近の祖先要素を取得
      const ancestorElm = elm.closest('.js-tab')
      const tabContent = ancestorElm.querySelectorAll('.js-tab_content')
      const tabContentArr = Array.prototype.slice.call(tabContent, 0)
      // タブのclassの値を変更
      ancestorElm.getElementsByClassName('is-act')[0].classList.remove('is-act')
      elm.classList.add('is-act')

      tabContentArr.forEach(function (content) {
        content.classList.remove('is-show')
        gsap.to(content, 0.2, { autoAlpha: 0, display: 'none' })
      })

      const groupTabs = ancestorElm.getElementsByClassName('js-tab_trg')
      const arrayTabs = Array.prototype.slice.call(groupTabs)
      const index = arrayTabs.indexOf(elm)
      tabContentArr[index].classList.add('is-show')
      gsap.to(tabContentArr[index], 0.2, { autoAlpha: 1, display: 'block', delay: 0.2 })
    }
  }
}
